import React, { useEffect } from 'react';
import { BAR_MULTIPLIER, MAX_BAR_HEIGHT } from '../hooks/useAudioHandler';
import {
	Send,
	Delete as DeleteIcon
} from '@material-ui/icons';
import { SendButton } from '../styles';
import { useNotifyAlert } from 'context/NotifyAlert';
import { useSelector } from 'react-redux';

const AudioRecorder = ( { isAudioDisabled, handleSendMessage, mediaRecorderRef, isRecording, recordingTimerRef, setIsRecording, recordingTime, setRecordingTime, audioLevels, cancelRecording, formatRecordingTime, useForm } ) => {
	const { setShowNotify } = useNotifyAlert();
	const userEmail = useSelector( state => state.auth.userLogin );

	const handleSendAudio = async () => {
		try {
			if ( mediaRecorderRef.current && isRecording ) {
				const { recorder, chunks } = mediaRecorderRef.current;

				recorder.stop();
				recorder.stream.getTracks().forEach( ( track ) => track.stop() );
				clearInterval( recordingTimerRef.current );
				setIsRecording( false );

				if ( chunks.length === 0 ) {
					throw new Error( 'Nenhum dado de áudio foi gravado' );
				}

				const audioBlob = new Blob( chunks, { type: 'audio/webm;codecs=opus' } );

				if ( audioBlob.size === 0 ) {
					throw new Error( 'Blob de áudio está vazio' );
				}

				const audioUrl = URL.createObjectURL( audioBlob );

				const base64Audio = await new Promise( ( resolve, reject ) => {
					const reader = new FileReader();
					reader.onloadend = () => {
						const base64String = reader.result.split( ',' )[1];
						resolve( base64String );
					};
					reader.onerror = ( error ) => {
						console.error( 'Erro na conversão para base64:', error );
						reject( error );
					};
					reader.readAsDataURL( audioBlob );
				} );

				const messageData = {
					mediaType  : 'audio',
					content    : base64Audio,
					storageUrl : audioUrl,
					createdAt  : new Date().toISOString(),
					status     : 'pending',
					duration   : recordingTime,
				};

				await handleSendMessage( messageData, useForm, userEmail );
				setRecordingTime( 0 );
			}
		} catch ( error ) {
			console.error( 'Erro ao enviar áudio:', error );
			setShowNotify( {
				status : 'error',
				text   : error.message || 'Erro ao enviar áudio.',
			} );
		}
	};

	useEffect( () => {
		return () => {
			if ( recordingTimerRef.current ) {
				clearInterval( recordingTimerRef.current );
			}
			if ( mediaRecorderRef.current ) {
				mediaRecorderRef.current.recorder.stream
					.getTracks()
					.forEach( ( track ) => track.stop() );
			}
		};
	}, [] ); //eslint-disable-line

	return (
		<div style={{
			width          : '100%',
			display        : 'flex',
			gap            : '8px',
			padding        : '8px 16px',
			background     : '#f0f2f5',
			borderRadius   : '8px',
			justifyContent : 'flex-end'
		}}>
			<button
				onClick={cancelRecording}
				style={{
					background     : 'none',
					border         : 'none',
					cursor         : 'pointer',
					padding        : '6px',
					display        : 'flex',
					alignItems     : 'center',
					justifyContent : 'center',
					color          : '#969ba2',
					gap            : '4px',
				}}
			>
				<DeleteIcon />
				<span>{formatRecordingTime( recordingTime )}</span>
			</button>

			<div
				style={{
					display        : 'flex',
					flexDirection  : 'row',
					alignItems     : 'center',
					borderRadius   : '50px',
					justifyContent : 'flex-end',
					gap            : '2px',
					minWidth       : '181px',
					paddingRight   : '8px',
				}}>
				{
					audioLevels?.map( ( level, i ) => (
						i % 2 === 0 && (
							<div key={i} style={{
								width          : '5px',
								height         : '50px',
								display        : 'flex',
								justifyContent : 'center',
								alignItems     : 'center',
								overflow       : 'hidden',
							}}>
								<div style={{
									width           : '4px',
									height          : `${Math.min( Math.max( level * ( BAR_MULTIPLIER + 4 ), 4 ), MAX_BAR_HEIGHT )}px`,
									backgroundColor : '#969ba2',
									borderRadius    : '50px',
									transition      : 'height 200ms ease-in-out',
									transformOrigin : 'center',
								}} />
							</div>
						)
					) )
				}
			</div>

			<div style={{
				display       : 'flex',
				flexDirection : 'row',
				alignItems    : 'center',
				gap           : '8px',
				padding       : '8px',
				paddingRight  : '0',
			}}>
				<SendButton
					type="button"
					disabled={isAudioDisabled}
					onClick={handleSendAudio}
				>
					<Send fontSize='small' className="text-white" />
				</SendButton>
			</div>
		</div>
	);
};

export default AudioRecorder;